export default "__VITE_ASSET__aad59c8a__"